// extracted by mini-css-extract-plugin
module.exports = {"tabs":"MyDocumentsPage_tabs_3r_oH","spinAround":"MyDocumentsPage_spinAround_UkdBN"};